import { useMonthPicker } from '../../../../../components/month-picker/useMonthPicker';
import { StatsFilters } from '../../../../../domain/statsFilters';

type MonthRangePickerProps = {
    monthYearRange: StatsFilters['monthYearRange'];
    onChange: (newMonthYearRange: NonNullable<StatsFilters['monthYearRange']>) => void;
}

export const MonthRangePicker = ({ monthYearRange, onChange }: MonthRangePickerProps) => {
    const handleFromMonthYearChange = (month: number, year: number) => {
        onChange({
            fromMonth: month,
            fromYear: year,
            toMonth: monthYearRange?.toMonth || month,
            toYear: monthYearRange?.toYear || year,
        });
    }

    const handleToMonthYearChange = (month: number, year: number) => {
        onChange({
            fromMonth: monthYearRange?.fromMonth || month,
            fromYear: monthYearRange?.fromYear || year,
            toMonth: month,
            toYear: year
        });
    }

    const { MonthPicker: FromMonthPicker } = useMonthPicker({
        month: monthYearRange?.fromMonth,
        year: monthYearRange?.fromYear,
        onMonthYearChange: handleFromMonthYearChange,
    });

    const { MonthPicker: ToMonthPicker } = useMonthPicker({
        month: monthYearRange?.toMonth,
        year: monthYearRange?.toYear,
        onMonthYearChange: handleToMonthYearChange
    });

    return <>
        <FromMonthPicker className="me-1" /> do <ToMonthPicker className="ms-1" />
    </>;
}